@if (spinner.show) {
  <div [@fadeIn]="'in'" class="overlay" [style.background-color]="spinner.bdColor"
    [style.z-index]="spinner.zIndex" [style.position]="spinner.fullScreen ? 'fixed' : 'absolute'">
    @if (!template) {
      <div [class]="spinner.class" [style.color]="spinner.color">
        @for (index of spinner.divArray; track index) {
          <div></div>
        }
      </div>
    }
    @if (template) {
      <div [innerHTML]="template | safeHtml"></div>
    }
    <div class="loading-text" [style.z-index]="spinner.zIndex">
      <ng-content></ng-content>
    </div>
  </div>
}